module.exports = __webpack_public_path__ + "img/sa.sad2ac71b.svg";